// ClientBudget stores scope twice: the singular FKs (`location`, `vertical`)
// and the M2M arrays (`location_ids`, `vertical_ids`). Rows written outside the
// serializer can carry only the FK, and the API sends the FK back only as
// `location_data` / `vertical_data` (the plain FK field is write-only). An
// empty array is truthy, so `location_ids || fallback` never reaches the
// fallback and those rows read as "All". Read scope through these helpers.
//
// A cleared picker sets `location_ids: []` and `location: ''` together; the
// empty string is deliberately not nullish, so a cleared row never falls back
// to the stale `location_data` it still carries.

const isBlank = (value) => value === null || value === undefined || value === '';

// Territory ids the segment covers, as numbers: the non-empty M2M, else the FK.
export function segmentLocationIds(segment) {
  const ids = (Array.isArray(segment?.location_ids) ? segment.location_ids : [])
    .filter((id) => !isBlank(id))
    .map(Number);
  if (ids.length) return ids;
  const single = segment?.location ?? segment?.location_data?.id;
  return isBlank(single) ? [] : [Number(single)];
}

// The segment's vertical id, or '' for "All": the FK, else the first M2M id.
export function segmentVerticalId(segment) {
  const vertical = segment?.vertical
    ?? segment?.vertical_data?.id
    ?? (Array.isArray(segment?.vertical_ids) ? segment.vertical_ids[0] : undefined);
  return isBlank(vertical) ? '' : vertical;
}

// Sorted, comma-joined territory ids — for dirty checks and duplicate keys,
// where [A,B] and [B,A] are the same segment.
export function segmentLocationKey(segment) {
  return segmentLocationIds(segment).sort((a, b) => a - b).join(',');
}
